import { Component, ViewChild, ElementRef, OnInit, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AdminService } from '../../shared/services/admin.service';
import { MaintenanceTableV4Component } from '../../techopsv4/maintenance/maintenance-table-v4/maintenance-table-v4.component';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ENTER } from '@angular/cdk/keycodes';
import { CommonModelService } from '../../padu-reporting/capability/common-model.service';
import { environment } from '../../../environments/environment';
import { MatFormField, MatOption } from '@angular/material/select';
import { MatChipGrid, MatChipRow, MatChipRemove, MatChipInput } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { AppModalComponent } from '../../shared/elements/app-modal/app-modal.component';
import { UserAccesssAddPopupComponent } from '../user-accesss-add-popup/user-accesss-add-popup.component';

@Component({
    selector: 'app-user-access-search',
    templateUrl: './user-access-search.component.html',
    styleUrls: ['./user-access-search.component.css'],
    imports: [MatFormField, MatChipGrid, MatChipRow, MatIcon, MatChipRemove, MatAutocompleteTrigger, MatChipInput, MatAutocomplete, MatOption, MaintenanceTableV4Component, AppModalComponent, UserAccesssAddPopupComponent],
    schemas: [NO_ERRORS_SCHEMA],
})
export class UserAccessSearchComponent implements OnInit {

 @ViewChild(MaintenanceTableV4Component) maintenanceTable: MaintenanceTableV4Component;
 @ViewChild('msidInput') msidInput: ElementRef;
 @ViewChild('addPopup') addPopup: any;
 msId: any;
 mail: string = '';
 selectedUsers: any = {};
 users: any[] = [];
 separatorKeysCodes: number[] = [ENTER];
 private subject: Subject<string> = new Subject();
 inputElement: any;
 matchedGroups: any[] = [];
 accessData: any;
 searched:boolean=false;
 featureAccessData: any[] = [];
 showLoader: boolean = false;
 expandAll: string = 'false';
 expanded_columns: string[] = [];
 allRowsExpanded = false;
 dataSourceDetails: MatTableDataSource<any> = new MatTableDataSource([]);
 selectedRecords: any[] = [];

  TABLE_COLUMNS: any = [
    {
      matColumnDef: 'select',
      key: 'select',
      label: '',
      width: '7% !important'
    },
    {
      key: 'Feature',
      label: 'Feature',
      filter: true,
      width: '15% !important',
      padding: '5px 5px 5px 0px !important',
      sortable: true
    },
    {
      key: 'Role',
      label: 'Role',
      filter: true,
      width: '15% !important',
      padding: '5px 5px 5px 0px !important',
      sortable: true
    },
    {
      key: 'Secure_Group',
      label: 'Secure Group',
      filter: true,
      width: '28% !important',
      padding: '5px 5px 5px 0px !important',
      sortable: true
    },
    {
      key: 'Description',
      label: 'Description',
      width: '15% !important',
      padding: '5px 5px 5px 0px !important',
      sortable: true
    },
    {
      key: 'Details',
      label: 'Details',
      width: '10% !important',
      sortable: true,
      padding: '0px 0px 0px 1.5rem !important'
    },
    {
      key: 'Actions',
      label: 'Actions',
      width: '9% !important',
      align: 'center !important',
      padding: '5px 10px 5px 0px !important'
    }
  ];
  DATA_SCHEMA = {
    Feature: 'text',
    Role: 'text',
    Secure_Group: 'text',
    Description: 'text',
    Details: 'text'
  };
  TABLE_CONFIG: any = {
    expandable: true,
    pageSize: 100,
    selection: true,
    edit: false,
    serverSidePagination: true,
    hideChildHeaderCheckbox: true,
    showAddButtonRoles: true,
    TABLE_CLASS: 'user-access-table-container'
  };

  sortConfig = {
    active: 'Feature',
    direction: 'asc'
  };
  
  constructor(
     public adminService: AdminService,
     public toaster: ToastrService,
     private capabilityService: CommonModelService,
  ) {
  }

  private normalizeColumnKey(key: string): string {
    return (key || '').toLowerCase().replace(/[_\s]/g, '');
  }

  private findColumnValue(record: any, targetColumn: string): any {
    if (!record || !targetColumn) return '';
    if (record[targetColumn] !== undefined) return record[targetColumn];

    const normalizedTarget = this.normalizeColumnKey(targetColumn);
    const keys = Object.keys(record);
    for (const key of keys) {
      if (this.normalizeColumnKey(key) === normalizedTarget) {
        return record[key];
      }
    }
    return '';
  }

  private buildDynamicChildColumns(columnNames: string[]): any[] {
    const safeCols = Array.isArray(columnNames) ? columnNames : [];
    return [
      {
        matColumnDef: 'select',
        key: 'select',
        label: '',
        width: '8% !important'
      },
      ...safeCols.map(colName => ({
        key: colName,
        label: colName,
        width: `${Math.floor(90 / Math.max(safeCols.length, 1))}% !important`,
        padding: '5px 5px 5px 0px !important',
        sortable: false
      }))
    ];
  }

  private getMultiuserConfig(feature: any): { column: string; separator: string } | null {
    try {
      const raw = feature?.Popup_Details;
      if (!raw) return null;
      const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
      const fields: any[] = parsed?.fields || [];
      for (const field of fields) {
        if (field?.multiuser) {
          return { column: field.multiuser.column, separator: field.multiuser.separator };
        }
      }
    } catch (e) {}
    return null;
  }

  private filterByParamColumn(records: any[], paramColumn: string): any[] {
    if (!paramColumn || !Array.isArray(records) || records.length === 0) return records;
    if (!this.msId) return records;
    // Only filter if this param column actually exists in the result data
    if (records[0]?.[paramColumn] === undefined) return records;
    const msId = String(this.msId).toLowerCase().trim();
    return records.filter(r => {
      const val = r?.[paramColumn];
      if (val == null) return false;
      const valStr = String(val).toLowerCase().trim();
      // Exact match OR the column contains a comma-separated list (multiuser) that includes the msId
      return valStr === msId || valStr.split(',').map(v => v.trim()).includes(msId);
    });
  }

  private detectRoleColumnFromData(records: any[], roleLower: string): string {
    if (!Array.isArray(records) || records.length === 0 || !roleLower) return '';
    const role = roleLower.toLowerCase().trim();
    for (const key of Object.keys(records[0] || {})) {
      const hasMatch = records.some(r => {
        const v = r?.[key];
        return v != null && String(v).toLowerCase().trim() === role;
      });
      if (hasMatch) return key;
    }
    return '';
  }

  private filterQueryResultByRole(queryResult: any[], roleLower: string, roleColumn: string): any[] {
    if (!Array.isArray(queryResult)) return queryResult;
    // If no role column is configured, data is already scoped by query params — return as-is
    if (!roleColumn) return queryResult;
    const role = roleLower.toLowerCase().trim();
    return queryResult.filter(record => {
      const val = record?.[roleColumn];
      return val != null && String(val).toLowerCase().trim() === role;
    });
  }

  private buildDetailRecords(records: any[], parentItem: any, columnNames: string[], hasRole: boolean): any[] {
    if (!Array.isArray(records) || records.length === 0) return [];
    const cols = Array.isArray(columnNames) ? columnNames : [];

    const detailRecords: any[] = [];
    for (const record of records) {
      const detailRecord: any = {
        ...record,
        _isChild: true,
        _parentRecord: { ...parentItem }
      };

      for (const colName of cols) {
        detailRecord[colName] = this.findColumnValue(record, colName);
      }

      detailRecord['hideCheckbox'] = !hasRole || !parentItem.deleteQuery;
      detailRecords.push(detailRecord);
    }
    return detailRecords;
  }

  ngOnInit() { 
    this.getFeatureAccessDetails();
    this.dataSourceDetails = new MatTableDataSource([]);
    this.subject.pipe(debounceTime(500)).subscribe(searchText => {
      this.handleSearch(searchText);
    });
  }

  getFeatureAccessDetails(){
    try {
      this.adminService.getFeatureAccessDetails().subscribe({
        next: (featureAccessData) => {
          this.featureAccessData = featureAccessData;
        },
        error: (err) => {
          console.error('Error fetching feature access details:', err);
           this.toaster.error(`Something went wrong`, '', { timeOut: 5000, positionClass: 'toast-top-center' });
        }
      });
    } catch (err) {
       console.error('Unexpected error in getFeatureAccessDetails:', err);
       this.toaster.error(`Something went wrong`, '', { timeOut: 5000, positionClass: 'toast-top-center' });
    }
  }

  keyUpSearch(event: any) {
    const value = event.target.value;
    this.inputElement = event;
    if (value) {
      this.subject.next(value);
    } else {
      this.users = [];
    }
  }

  handleSearch(value: string) {
    this.capabilityService.getLDAPUsers(value).subscribe(dataStream => {
      this.users = dataStream.map(element => ({
        givenName: element.givenName,
        sn: element.sn,
        mail: element.mail,
        displayName: element.displayName,
        employeeID: element.employeeID,
        MSId: element.cn,
        middleName: element.middleName,
        memberOf: element.memberOf || [],
      }));
    }, (error) => {
      console.error(error);
      this.toaster.error('Error searching LDAP users', '', { timeOut: 5000, positionClass: 'toast-top-center' });
    });
  }

  selected(event: any) {
    this.selectedUsers = event.option.value;
    this.msId = this.selectedUsers.MSId || this.selectedUsers.msid;
    this.mail = this.selectedUsers.mail || '';
    if (this.inputElement) {
      this.inputElement.target.value = '';
    }
    this.users = [];

    const memberOfArray = this.selectedUsers.memberOf || [];
    const secureGroupsObj = JSON.parse(sessionStorage.getItem('secureGroups'));
    const secureGroupKeys = Object.keys(secureGroupsObj || {});
    const matchedGroups = [];
    for (const secureKey of secureGroupKeys) {
      const isFound = memberOfArray.some((memberOfEntry) => {
        const cnMatch = memberOfEntry //.match(/^CN=([^,]+)/);
        return cnMatch === secureKey;
      });
      if (isFound) {
        matchedGroups.push(secureKey);
      }
    }
    this.matchedGroups = matchedGroups;
     this.searched=true;
     this.checkUserAccessForAllFeatures();
  }

  remove() {
    this.selectedUsers = {};
    this.msId = null;
    this.users = [];
  }
  selectedRowForAdd: any = {};

  checkexist(user: any) {
    return false;
  }

  isAddDisabledForRow = (element: any): boolean => {
    const raw = element.Popup_Details;
    
const secureGroups = (element.Secure_Group || '')
  .split('\n')
  .map((sg: string) => sg.trim())
  .filter((sg: string) => sg && sg.toUpperCase() !== 'NA');

if (secureGroups.length === 0) {
  element.addDisabledTooltip = '';
  // No secure group configured, skip secure group validation
} else if (environment.environmentName != 'Prod') {
  const matchingGroup = secureGroups.find((sg: string) =>
    sg.includes('Dev') &&
    sg.includes('(Yes)')
  );

  if (!matchingGroup) {
    element.addDisabledTooltip = `${secureGroups
      .filter((sg: string) => sg.includes('Dev'))
      .map((sg: string) => sg.replace(/\s*\((Yes|No)\)/, ''))
      .join(', ')} secure group is required`;
    return true;
  }
} else {
  const matchingGroup = secureGroups.find((sg: string) =>
    !sg.includes('Dev') &&
    sg.includes('(Yes)')
  );

  if (!matchingGroup) {
    element.addDisabledTooltip = `${secureGroups
      .filter((sg: string) => !sg.includes('Dev'))
      .map((sg: string) => sg.replace(/\s*\((Yes|No)\)/, ''))
      .join(', ')} secure group is required`;
    return true;
  }
}

    if (raw) {
      try {
        const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
        const fields: any[] = parsed.fields || [];
        if (
          fields.length > 0 &&
          fields.every((f: any) => f.default_selection === 'All') &&
          (element.Role || '').includes('(Yes)')
        ) {
          return true;
        }
      } catch (e) {}
    }
    return false;
  };

  onAddRow(row: any) {
    this.selectedRowForAdd = { ...row };
    const rawPopupDetails = row?.Popup_Details;
    let allDefault = false;
    if (rawPopupDetails) {
      try {
        const parsed = typeof rawPopupDetails === 'string' ? JSON.parse(rawPopupDetails) : rawPopupDetails;
        const fields: any[] = parsed.fields || [];
        allDefault = fields.length > 0 && fields.every((f: any) => f.default_selection === 'All');
      } catch (e) {}
    }
    if (!allDefault) {
      this.addPopup?.show();
    }
  }

  closeAddPopup() {
    this.addPopup?.hide();
    this.selectedRowForAdd = {};
  }

  collapseAllFunc(data) {
    if (data == true) {
      this.allRowsExpanded = true;
    } else {
      this.allRowsExpanded = false;
    }
  }

  expandAllFunc() {
    if (this.expandAll == 'true' || this.allRowsExpanded == true) {
      if (this.expandAll == 'false') this.expandAll = 'false1';
      else this.expandAll = 'false';
      this.allRowsExpanded = false;
    } else {
      this.expandAll = 'true';
      this.allRowsExpanded = true;
    }
  }

  private handleTableSelectionCascade(event: any): void {
    if (!this.maintenanceTable) return;

    const tableRef = this.maintenanceTable;
    if (event?.type === 'singlecheck' && event.row) {
      this.handleSingleCheckEvent(tableRef, event);
      return;
    }

    if (event?.type === 'selectall') {
      this.handleSelectAllEvent(tableRef);
    }
    // clearall: selection.clear() in masterToggle already wipes parents + children
  }

  private handleSingleCheckEvent(tableRef: any, event: any): void {
    const row = event.row;

    if (row?._isChild && row._parentRecord) {
      this.syncParentSelectionForChild(tableRef, row);
      return;
    }

    if (row?.childDataSource?.data?.length > 0) {
      this.toggleChildrenForParentRow(tableRef, row, !!event.checked);
    }
  }

  private syncParentSelectionForChild(tableRef: any, childRow: any): void {
    const parentRow = tableRef.dataSource.data.find((r: any) => r.id === childRow._parentRecord.id);
    if (!parentRow) return;

    const children: any[] = parentRow.childDataSource?.data || [];
    const selectableChildren = children.filter((c: any) => !c.hideCheckbox);
    const allChildrenSelected =
      selectableChildren.length > 0 &&
      selectableChildren.every((c: any) => tableRef.selection.isSelected(c));

    if (allChildrenSelected) {
      tableRef.selection.select(parentRow);
    } else {
      tableRef.selection.deselect(parentRow);
    }
  }

  private toggleChildrenForParentRow(tableRef: any, parentRow: any, isChecked: boolean): void {
    const children: any[] = parentRow.childDataSource?.data || [];
    for (const child of children) {
      if (child.hideCheckbox) continue;
      if (isChecked) {
        tableRef.selection.select(child);
      } else {
        tableRef.selection.deselect(child);
      }
    }
  }

  private handleSelectAllEvent(tableRef: any): void {
    const rows: any[] = tableRef.dataSource?.data || [];
    for (const row of rows) {
      if (row.hideCheckbox || !row.childDataSource?.data?.length) continue;
      for (const child of row.childDataSource.data) {
        if (!child.hideCheckbox) {
          tableRef.selection.select(child);
        }
      }
    }
  }

  private getRawSelection(event: any): any[] {
    if (this.maintenanceTable?.selection) {
      return this.maintenanceTable.selection.selected.filter(record => !record.hideCheckbox);
    }

    let rawSelection: any[] = [];
    if (Array.isArray(event)) {
      rawSelection = event;
    } else if (event && Array.isArray(event.data)) {
      rawSelection = event.data;
    } else if (event && typeof event === 'object' && Array.isArray(event.selected)) {
      rawSelection = event.selected;
    }

    return rawSelection.filter(record => !record.hideCheckbox);
  }

  private getParentKey(parentRecord: any): string {
    const id = parentRecord.id || parentRecord.featureId || parentRecord.ID || '';
    const feature = parentRecord.Feature || '';
    const role = parentRecord.Role || '';
    return `${id}_${feature}_${role}`;
  }

  private createParentSelectionEntry(record: any): any {
    return {
      msid: this.msId,
      id: record.id,
      featureId: record.featureId,
      Feature: record.Feature,
      Role: record.Role,
      Secure_Group: record.Secure_Group,
      Description: record.Description,
      deleteQuery: record.deleteQuery || record.Delete_Query?.trim(),
      objName: record.objName || record.Obj_Name,
      detailsQuery: record.detailsQuery || record.Details_Query,
      detailsColumn: record.detailsColumn || record.Details_Column,
      roleColumn: record.roleColumn || record.Role_Column || '',
      _selectedChildren: []
    };
  }

  private addChildToParentSelection(parent: any, childRecord: any): void {
    const parentColumns = parent.detailsQuery
      ? (parent.detailsColumn || '').split(',').map(c => c.trim())
      : [];

    const cleanChild: any = {};
    for (const colName of parentColumns) {
      if (childRecord[colName] !== undefined) {
        cleanChild[colName] = childRecord[colName];
      }
    }

    // Use the feature's configured Role_Column as the key; skip if not configured (params-based feature)
    if (parent.roleColumn) {
      cleanChild[parent.roleColumn] = parent.Role ? parent.Role.split('(')[0].trim() : parent.Role;
    }
    parent._selectedChildren.push(cleanChild);
  }

  private buildSelectedRecords(rawSelection: any[]): any[] {
    const parentMap = new Map<string, any>();

    for (let index = 0; index < rawSelection.length; index++) {
      const record = rawSelection[index];
      console.log(`Processing record ${index}:`, {
        _isChild: record._isChild,
        _isParent: record._isParent,
        id: record.id || record.ID,
        hasParentRecord: !!record._parentRecord
      });

      if (record._isChild && record._parentRecord) {
        const parentSource = record._parentRecord;
        const parentKey = this.getParentKey(parentSource);
        if (!parentMap.has(parentKey)) {
          parentMap.set(parentKey, this.createParentSelectionEntry(parentSource));
        }

        const parent = parentMap.get(parentKey);
        this.addChildToParentSelection(parent, record);
        continue;
      }

      if (record._isParent) {
        const parentKey = this.getParentKey(record);
        if (!parentMap.has(parentKey)) {
          parentMap.set(parentKey, this.createParentSelectionEntry(record));
        }
        continue;
      }

      console.warn('Record has no _isChild or _isParent flag:', record);
    }

    return Array.from(parentMap.values());
  }

  checkBoxEvent(event) {
    this.handleTableSelectionCascade(event);
    const rawSelection = this.getRawSelection(event);
    this.selectedRecords = this.buildSelectedRecords(rawSelection);
    this.selectedRecords.forEach((parent, i) => {
      console.log(`Parent ${i} has ${parent._selectedChildren?.length || 0} selected children`);
    });
  }

  private buildAccessDataRows(): any[] {
    return this.featureAccessData.map(item => ({
      Feature: item.Feature,
      Role: item.Role,
      Secure_Group: item.Secure_Group,
      Description: item.Description || '',
      Details: '',
      featureId: item.ID,
      params: item.Params,
      detailsColumn: item.Details_Column,
      detailsQuery: item.Details_Query,
      deleteQuery: item.Delete_Query?.trim(),
      objName: item.Obj_Name,
      Delete_Query: item.Delete_Query?.trim(),
      Obj_Name: item.Obj_Name,
      ...item,
      // After spread so it wins over any conflicting camelCase property from the API response
      roleColumn: item.Role_Column || item.roleColumn || '',
      // Composite key matching the query key sent in buildQueryParamsMap
      resultKey: item.Params ? `${item.Obj_Name || ''}||${item.Params}` : (item.Obj_Name || ''),
      popupDetails: item.Popup_Details,
    }));
  }

  private buildQueryParamsMap(): any[] {
    const queryParamsMap: any[] = [];
    const seenCombinations = new Set<string>();

    for (const feature of this.featureAccessData) {
      if (!feature?.Details_Query || !feature?.Params) continue;

      const queryKey = (feature.Obj_Name || '').toString();
      if (!queryKey) continue;

      // Each unique Obj_Name + Params combination gets its own record.
      // 'query' stays as plain Obj_Name so the backend can look up the SQL.
      // 'key' carries the composite identifier — the backend should use this
      // as the result key in the response so each trigger's result is distinct.
      const compositeKey = `${queryKey}||${feature.Params}`;
      if (seenCombinations.has(compositeKey)) continue;

      seenCombinations.add(compositeKey);
      const multiuserConfig = this.getMultiuserConfig(feature);
      const entry: any = {
        query: queryKey,
        key: compositeKey,
        params: { [feature.Params]: this.msId }
      };
      if (multiuserConfig) {
        entry.multiuser = { column: multiuserConfig.column, separator: multiuserConfig.separator };
      }
      queryParamsMap.push(entry);
    }

    return queryParamsMap;
  }

  private extractQueryResultsMap(results: any[]): Map<string, any> {
    const queryResultsMap = new Map<string, any>();

    for (const resultObj of results) {
      if (!resultObj || typeof resultObj !== 'object') continue;

      const queryKey = Object.keys(resultObj)[0];
      if (!queryKey) continue;

      const incoming = resultObj[queryKey];
      const existing = queryResultsMap.get(queryKey.trim());
      // Merge results for the same key so multiple param triggers for the same
      // Obj_Name are combined — filterByParamColumn then scopes each row to its own param.
      if (existing && Array.isArray(existing) && Array.isArray(incoming)) {
        queryResultsMap.set(queryKey.trim(), [...existing, ...incoming]);
      } else {
        queryResultsMap.set(queryKey.trim(), incoming);
      }
    }

    return queryResultsMap;
  }

  private extractRecordsFromResult(resultItem: any): any[] {
    if (Array.isArray(resultItem)) return resultItem;
    if (resultItem && typeof resultItem === 'object') {
      const firstValue = Object.values(resultItem)[0];
      return Array.isArray(firstValue) ? firstValue : [];
    }
    return [];
  }

  private extractAllUserRoles(results: any[], roleColumnByQuery: Map<string, string>): string[] {
    const allUserRoles: string[] = [];

    for (const resultItem of results) {
      if (!resultItem || typeof resultItem !== 'object' || Array.isArray(resultItem)) continue;

      const queryKey = (Object.keys(resultItem)[0] || '').trim();
      const records: any[] = Array.isArray(Object.values(resultItem)[0])
        ? (Object.values(resultItem)[0] as any[])
        : [];
      if (!records.length) continue;

      const roleCol = roleColumnByQuery.get(queryKey) || '';
      if (!roleCol) continue; // params-based feature — role determined by record presence, not a column value

      for (const record of records) {
        const roleValue = record?.[roleCol];
        if (!roleValue) continue;
        allUserRoles.push(String(roleValue).toLowerCase().trim());
      }
    }

    return allUserRoles;
  }

  private applyRoleStatus(item: any, hasRole: boolean, baseRole: string, roleLower: string): void {
    if (!item.objName) {
      item.Role = `${baseRole} (NA)`;
      return;
    }

    item.Role = hasRole
      ? `${baseRole} (Yes)`
      : `${baseRole} (No)`;
  }

  private applySecureGroupStatus(item: any, userGroup: any[]): void {
    if (typeof item.Secure_Group !== 'string' || item.Secure_Group === 'NA') return;

    const cleanGroup = item.Secure_Group.replace(/ \(Yes\)|\(No\)/g, '').trim();
    const hasGroup = userGroup.includes(cleanGroup);
    item.Secure_Group = hasGroup ? `${cleanGroup} (Yes)` : `${cleanGroup} (No)`;
  }

  private hasSecureGroupAccess(item: any): boolean {
    const secureGroupRaw = typeof item.Secure_Group === 'string' ? item.Secure_Group : '';
    const isSecureGroupNA = secureGroupRaw.replace(/ \(Yes\)|\(No\)/g, '').trim() === 'NA';
    return isSecureGroupNA || secureGroupRaw.includes('(Yes)');
  }

  private clearRowDetails(item: any): void {
    item.Details = '';
    item['details'] = [];
    item['childDataSource'] = new MatTableDataSource([]);
  }

  private setRowDetails(item: any, hasRole: boolean, roleLower: string, queryResultsMap: Map<string, any>): void {
    const canLoadDetails = hasRole && item.detailsColumn && item.detailsQuery && this.hasSecureGroupAccess(item);
    if (!canLoadDetails) {
      this.clearRowDetails(item);
      return;
    }

    const queryKey = (item.resultKey && queryResultsMap.has(item.resultKey))
      ? item.resultKey
      : (item.Obj_Name || item.objName);
    const raw = queryResultsMap.get(queryKey);
    // Scope to records matching this row's specific param column so two rows
    // sharing the same Obj_Name but different Params each see their own data.
    const queryResult = this.filterByParamColumn(Array.isArray(raw) ? raw : [], item.params);

    if (!queryResult || queryResult.length === 0) {
      this.clearRowDetails(item);
      return;
    }

    const columnNames = item.detailsColumn.split(',').map(col => col.trim());
    const dynamicColumns = this.buildDynamicChildColumns(columnNames);
    const filteredQueryResult = this.filterQueryResultByRole(queryResult, roleLower, item.roleColumn);
    const detailRecords = this.buildDetailRecords(filteredQueryResult, item, columnNames, hasRole);

    item.Details = detailRecords.length > 0 ? detailRecords.length : '';
    item['details'] = detailRecords;
    item['customColumns'] = dynamicColumns;
    item['displayedChildColumns'] = ['select', ...columnNames];
    item['childDataSource'] = new MatTableDataSource(detailRecords);
  }

  private applyAccessToRows(data: any[], allUserRoles: string[], userGroup: any[], queryResultsMap: Map<string, any>): void {
    // Pre-pass: resolve the effective role column once per Obj_Name.
    // Tries each feature row's role name against the query result until one matches —
    // so ALL rows sharing the same query use the SAME role column for consistent filtering.
    const resolvedRoleColByObjName = new Map<string, string>();
    for (const item of data) {
      const qKey = (item.resultKey && queryResultsMap.has(item.resultKey))
        ? item.resultKey
        : (item.Obj_Name || item.objName);
      if (resolvedRoleColByObjName.get(qKey)) continue;
      if (item.roleColumn) {
        resolvedRoleColByObjName.set(qKey, item.roleColumn);
        continue;
      }
      const rawResult = queryResultsMap.get(qKey);
      // Scope to this row's param column before role-column detection
      const paramResult: any[] = this.filterByParamColumn(
        Array.isArray(rawResult) ? rawResult : [], item.params
      );
      const roleLower = (item.Role || '').replace(/ \(Yes\)|\(No\)/g, '').trim().toLowerCase();
      const detected = this.detectRoleColumnFromData(paramResult, roleLower);
      if (detected) resolvedRoleColByObjName.set(qKey, detected);
    }

    for (let index = 0; index < data.length; index++) {
      const item = data[index];
      const baseRole = item.Role.replace(/ \(Yes\)|\(No\)/g, '').trim();
      const roleLower = baseRole.toLowerCase().trim();

      const queryKey = (item.resultKey && queryResultsMap.has(item.resultKey))
        ? item.resultKey
        : (item.Obj_Name || item.objName);
      const rawResult = queryResultsMap.get(queryKey);
      // Scope to this row's param column — each row only considers records for its own Params
      const resultArray: any[] = this.filterByParamColumn(
        Array.isArray(rawResult) ? rawResult : [], item.params
      );

      // Use the resolved role column for this Obj_Name (configured > auto-detected > empty = params-based)
      const effectiveRoleCol = resolvedRoleColByObjName.get(queryKey) || '';
      // Propagate to item.roleColumn so setRowDetails/filterQueryResultByRole use the correct column
      if (!item.roleColumn && effectiveRoleCol) {
        item.roleColumn = effectiveRoleCol;
      }

      // Role column found → user has this role only if a matching record exists in the result
      // No role column → params-based: user has access if any records exist for their msId
      const hasRole = effectiveRoleCol
        ? resultArray.some(r => String(r[effectiveRoleCol] ?? '').toLowerCase().trim() === roleLower)
        : resultArray.length > 0;

      this.applyRoleStatus(item, hasRole, baseRole, roleLower);
      item['hideCheckbox'] = !hasRole || !item.deleteQuery;
      item['_isParent'] = true;
      this.applySecureGroupStatus(item, userGroup);
      item.Description = item.Description || '';
      item['id'] = index;
      this.setRowDetails(item, hasRole, roleLower, queryResultsMap);
    }
  }

  private updateTableData(data: any[]): void {
    const mergedData = this.clubSubsetSecureGroupRows(data);
    this.dataSourceDetails = new MatTableDataSource(mergedData);
    this.TABLE_CONFIG.totalItems = mergedData.length;
    this.TABLE_CONFIG.pageSize = mergedData.length > 0 ? mergedData.length : 100;
    this.showLoader = false;
  }

  private handleUserAccessError(error: any): void {
    console.error('Error executing queries:', error);
    this.showLoader = false;
    this.dataSourceDetails = new MatTableDataSource([]);
    this.TABLE_CONFIG.totalItems = 0;
    this.toaster.error('Error while fetching user details', '', { timeOut: 5000, positionClass: 'toast-top-center' });
  }

  checkUserAccessForAllFeatures() {
    this.showLoader = true;
    const data = this.buildAccessDataRows();
    const queryParamsMap = this.buildQueryParamsMap();
    console.log('Constructed queryParamsMap:', queryParamsMap);

    firstValueFrom(this.adminService.getUserAccessDetails(queryParamsMap))
      .then(response => {
        const userGroup = this.matchedGroups;
        const { matchedGroups: _matchedGroups, ...queryResults } = response || {};
        const results = Object.values(queryResults || {});

        const queryResultsMap = this.extractQueryResultsMap(results as any[]);

        // Build queryKey → Role_Column map so extractAllUserRoles uses the dynamic column per feature
        const roleColumnByQuery = new Map<string, string>(
          this.featureAccessData
            .filter(f => f.Obj_Name && f.Role_Column)
            .map(f => [(f.Obj_Name || '').toString().trim(), (f.Role_Column || '').toString()])
        );
        const allUserRoles = this.extractAllUserRoles(results as any[], roleColumnByQuery);

        this.applyAccessToRows(data, allUserRoles, userGroup, queryResultsMap);
        this.updateTableData(data);
      })
      .catch(error => {
        this.handleUserAccessError(error);
      });
  }

  clubSubsetSecureGroupRows(data: any[]): any[] {
    const cleanSG = (sg: string) => (sg || '').replace(/ \(Yes\)|\(No\)/g, '').trim();
    const cleanRole = (role: string) => (role || '').replace(/ \(Yes\)|\(No\)|\(NA\)/g, '').trim();
    const isSGSubset = (a: string, b: string): boolean => {
      if (!a || !b || a === b) return false;
      return (b.startsWith(a) && b[a.length] === '_') || (a.startsWith(b) && a[b.length] === '_');
    };

    const usedMergeIndices = new Set<number>();
    const mergedData: any[] = [];

    for (let i = 0; i < data.length; i++) {
      if (usedMergeIndices.has(i)) continue;
      const itemA = data[i];
      const sgCleanA = cleanSG(itemA.Secure_Group);
      const roleCleanA = cleanRole(itemA.Role);

      let partnerIdx = -1;
      for (let j = i + 1; j < data.length; j++) {
        if (usedMergeIndices.has(j)) continue;
        const itemB = data[j];
        if (itemA.Feature !== itemB.Feature) continue;
        if (roleCleanA !== cleanRole(itemB.Role)) continue;
        if (isSGSubset(sgCleanA, cleanSG(itemB.Secure_Group))) {
          partnerIdx = j;
          break;
        }
      }

      if (partnerIdx >= 0) {
        usedMergeIndices.add(partnerIdx);
        const itemB = data[partnerIdx];
        const mergedItem = { ...itemA };
        mergedItem.Secure_Group = `${itemA.Secure_Group}\n${itemB.Secure_Group}`;
        mergedItem.hideCheckbox = itemA.hideCheckbox && itemB.hideCheckbox;
        const childrenA: any[] = itemA.childDataSource?.data || [];
        const childrenB: any[] = itemB.childDataSource?.data || [];
        const mergedChildren = childrenA.length > 0 ? childrenA : childrenB;
        mergedItem['details'] = mergedChildren;
        mergedItem['childDataSource'] = new MatTableDataSource(mergedChildren);
        mergedItem.Details = mergedChildren.length > 0 ? mergedChildren.length : '';
        // Pick from whichever item actually has them so the child table renders its columns correctly.
        const colSource = itemA.customColumns ? itemA : itemB;
        mergedItem['customColumns'] = colSource.customColumns;
        mergedItem['displayedChildColumns'] = colSource.displayedChildColumns;
        mergedData.push(mergedItem);
      } else {
        mergedData.push(itemA);
      }
    }

    return mergedData;
  }

  deleteSelectedRoles() {
    const segregated: Record<string, { msid: string, Mail: string, selectedChildren: any[], deleteQuery: string | null, detailsColumn: string }> = {};
    this.selectedRecords.forEach((record: any) => {
      const key = record.objName;
      if (!segregated[key]) {
        segregated[key] = {
          msid: record.msid,
          Mail: this.mail,
          selectedChildren: record._selectedChildren || [],
          deleteQuery: record.deleteQuery,
          detailsColumn: record.detailsColumn
        };
      } else {
        (record._selectedChildren || []).forEach((child: any) => {
          const serialized = JSON.stringify(child);
          if (!segregated[key].selectedChildren.some(c => JSON.stringify(c) === serialized)) {
            segregated[key].selectedChildren.push(child);
          }
        });
      }
    });

    console.log('Segregated records:', segregated);
    this.adminService.deleteUserAccessDetails(segregated).subscribe({
      next: (res) => {
        this.checkUserAccessForAllFeatures();
        this.toaster.success('Access deleted successfully', '', { timeOut: 5000, positionClass: 'toast-top-center' });
      },
      error: (err) => {
        console.error(err);
        this.toaster.error('Error while deleting access', '', { timeOut: 5000, positionClass: 'toast-top-center' });
      }
    });
  }
}
